import React from 'lib/react';
import { useSelector } from 'lib/redux';
import SRSValidationBannerSuccessComponent from './components/SRSValidationBannerSuccess.component';
import SRSBranchEmployeeComponent from './SRSBranchEmployee';

function SRS() {
  const {
    isSRSBranchEmployee,
    myevRefreshSrsBilling,
    srsValidation,
  } = useSelector(({
    userData, featureFlag, srs,
  }) => ({
    isSRSBranchEmployee: userData.initParameters?.isSRSBranchEmployee,
    myevRefreshSrsBilling: featureFlag.myevRefreshSrsBilling,
    srsValidation: srs.srsValidation,
  }));

  if (!myevRefreshSrsBilling || !isSRSBranchEmployee) return null;

  return (
    <>
      {srsValidation.checked && srsValidation.showSuccess && <SRSValidationBannerSuccessComponent />}
      {!srsValidation.success && <SRSBranchEmployeeComponent />}
    </>
  );
}

export default SRS;
